import { COLORS } from "@styles";
import { Typography } from "@mui/material";

export type TCustomChipVariant =
  | 'default'
  | 'success'
  | 'warning'
  | 'error'
  | 'dark'
  | 'info'
  | 'help'
  | 'purpleGradient';

interface ICustomChipProps {
  label: string;
  variant: TCustomChipVariant;
  small?: boolean;
  // eslint-disable-next-line react/require-default-props
  icon?: React.ReactNode;
}

const styles = {
  default: {
    backgroundColor: COLORS.ELEKTRAFI_NEUTRAL,
    color: COLORS.NEUTRAL_WHITE,
  },
  success: {
    backgroundColor: COLORS.POSITIVE_NEUTRAL,
    color: COLORS.POSITIVE_LIGHT,
  },
  warning: {
    backgroundColor: COLORS.WARNING_NEUTRAL,
    color: COLORS.NEUTRAL_DARK_2,
  },
  error: {
    backgroundColor: COLORS.NEGATIVE_NEUTRAL,
    color: COLORS.NEGATIVE_LIGHT,
  },
  dark: {
    backgroundColor: COLORS.NEUTRAL_DARK_1,
    color: COLORS.NEUTRAL_LIGHT_3,
  },
  info: {
    backgroundColor: COLORS.INFO_NEUTRAL,
    color: COLORS.INFO_LIGHT,
  },
  help: {
    backgroundColor: COLORS.HELP_NEUTRAL,
    color: COLORS.NEUTRAL_LIGHT_3,
  },
  purpleGradient: {
    background: `linear-gradient(223deg, ${COLORS.GRADIENT_PURPLE_NEUTRAL} 0%, ${COLORS.GRADIENT_BLUE_NEUTRAL} 103.78%)`,
    color: COLORS.NEUTRAL_WHITE,
  },
  container: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '2rem',
    gap: '0.625rem',
    flexShrink: 0,
    padding: '0.25rem 0.5rem',
    borderRadius: '0.5rem',
  },
  small: {
    height: '1.5rem',
  },
}

const getStyles = (variant: TCustomChipVariant, small?: boolean) => ({
  ...styles.container,
  ...styles[variant],
  ...(small && styles.small),
})

/**
 * Custom Chip component
 * @props label: string, variant: TCustomChipVariant, icon?: React.ReactNode
 * @returns 
 */
export function CustomChip({ label, variant, icon, small }: ICustomChipProps) {
  return (
    <div style={getStyles(variant, small)}>
      {icon && icon}
      <Typography variant='body1'>{label}</Typography>
    </div>
  )
}

CustomChip.defaultProps = {
  small: false,
}